// extracted by mini-css-extract-plugin
export default {"enemy_blobb_div":"EnemyBlobbs_enemy_blobb_div__UwWL6","fade-in":"EnemyBlobbs_fade-in__965m6"};